import { ref, computed } from 'vue';
import { useForm } from './form';
import { useInvestmentFundApi } from '../../../api/investment-fund-api';

const isFormLoading = ref(false);
const isTableLoading = ref(false);
const isTechnicalError = ref(false);

const BOTH = null;
const MAX_PAGE_SIZE = 10;

const funds = ref([]);
const periods = ref([]);
const groups = ref([]);
const risks = ref([]);
const currencies = [
	{ key: 'HUF', value: 'Forint' },
	{ key: 'FOREIGN', value: 'Deviza' },
	{ key: BOTH, value: 'Mindkettő' }
];

const results = ref([]);
const totalElements = ref(0);
const currentPage = ref(1);

const hasSearchResult = ref(true);

export const useStore = () => {
	const { model, clearModel } = useForm();
	const { init, search } = useInvestmentFundApi();

	const initialize = async () => {
		isFormLoading.value = true;
		try {
			const { data } = await init();
			funds.value = data.funds.sort((a, b) => a.name.localeCompare(b.name));
			periods.value = data.periods;
			groups.value = data.groups;
			risks.value = data.risks;
		} catch (e) {
			isTechnicalError.value = true;
		} finally {
			isFormLoading.value = false;
		}
	};

	const shownFunds = computed(() => {
		let data = funds.value;
		if (model.investmentPeriod) {
			data = data.filter((fund) => fund.investmentPeriod === model.investmentPeriod);
		}
		if (model.groupName) {
			data = data.filter((fund) => fund.groupName === model.groupName);
		}
		if (model.riskId) {
			data = data.filter((fund) => fund.riskId === model.riskId);
		}
		if (model.currency) {
			data = data.filter((fund) => fund.currency === model.currency);
		}
		return data;
	});

	const searchFunds = async () => {
		isTableLoading.value = true;
		try {
			const params = { ...model, page: currentPage.value - 1, 'page-size': MAX_PAGE_SIZE };
			const { data } = await search(params);
			totalElements.value = data.totalElements;
			results.value = data.content;
			hasSearchResult.value = totalElements.value != 0 && results.value.length;
		} catch (e) {
			isTechnicalError.value = true;
		} finally {
			isTableLoading.value = false;
		}
	};

	const clear = () => {
		clearModel();
		results.value = [];
		totalElements.value = 0;
		currentPage.value = 1;
	};

	return {
		isFormLoading,
		isTableLoading,
		isTechnicalError,
		funds: shownFunds,
		groups,
		risks,
		periods,
		currencies,
		init: initialize,
		search: searchFunds,
		clear,
		totalElements,
		results,
		currentPage,
		hasSearchResult,
		MAX_PAGE_SIZE
	};
};
